import { render, staticRenderFns } from "./QuestionEditDetails.vue?vue&type=template&id=6fc5cf00"
import script from "./QuestionEditDetails.vue?vue&type=script&lang=js"
export * from "./QuestionEditDetails.vue?vue&type=script&lang=js"
import style0 from "./QuestionEditDetails.vue?vue&type=style&index=0&id=6fc5cf00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports